import React, { useState } from 'react'
import Dropdown from '@cmp/site/Dropdown'

export type DropdownType = {
  [key: string]: BooleanObjectType
}

export type BooleanObjectType = {
  [key: string]: boolean
}

type StringObjectType = {
  [key: string]: string
}

const DropdownTree = ({
  dropdowns = {},
  categories = {},
  onDropdownUpdate,
  onSelectAll
}: {
  dropdowns: DropdownType
  categories: BooleanObjectType
  onDropdownUpdate: (t: DropdownType) => void
  onSelectAll: (t: BooleanObjectType) => void
}) => {
  // Stores information about which dropdowns are open
  const [open, setOpen] = useState<BooleanObjectType>({})

  const [allSelected, setAllSelected] = useState<BooleanObjectType>(
    Object.keys(dropdowns)
      .map(key => ({ [key]: false, all: false }))
      .reduce((obj, item) => Object.assign(obj, item), {})
  )

  const getCategoryLabel = (category: string) => {
    const labelDict: StringObjectType = {
      Tækifæri: 'Tegund tækifæris',
      Fjármögnun: 'Tegund fjármögnunar'
    }
    return labelDict.hasOwnProperty(category) ? labelDict[category] : category
  }

  const updateAll = (category: string) => {
    setOpen({ ...open, [category]: true })
    setAllSelected({ ...allSelected, [category]: !allSelected[category] })
  }

  // Handles child checkbox clicking
  const onClickCheckbox = (category: string, tag: string, value: boolean) => {
    if (tag === 'all') {
      // Check all tags
      const newObj = Object.assign({}, dropdowns)
      Object.keys(newObj[category]).forEach(key => {
        newObj[category][key] = !allSelected[category]
      })
      onDropdownUpdate(newObj)
      updateAll(category)
    } else {
      // Update select all tag based on number of tags selected
      if (!value) {
        setAllSelected({ ...allSelected, [category]: false })
      } else {
        if (
          Object.values(dropdowns[category]).filter(item => !item).length === 1
        ) {
          setAllSelected({ ...allSelected, [category]: true })
        }
      }
      onDropdownUpdate({
        ...dropdowns,
        [category]: { ...dropdowns[category], [tag]: value }
      })
    }
  }

  // Handles clicks to parent checkboxes
  const onClickSelectAll = (category: string) => {
    if (category === 'all') {
      const newObj = Object.assign({}, categories)
      Object.keys(newObj).forEach(key => {
        newObj[key] = !allSelected[category]
      })
      onSelectAll(newObj)
      updateAll(category)
    } else {
      // Update select all checkbox based on current selection
      if (categories[category]) {
        setAllSelected({ ...allSelected, all: false })
      } else {
        if (Object.values(categories).filter(item => !item).length === 1) {
          setAllSelected({ ...allSelected, all: true })
        }
      }
      onSelectAll({
        ...categories,
        [category]: !categories[category]
      })
    }
  }

  return (
    <div className='d-flex filter-dropdown flex-wrap'>
      {/* Select all dropdown */}
      <Dropdown
        open={open}
        setOpen={setOpen}
        categories={categories}
        category='all'
        allSelected={allSelected['all']}
        onSelect={onClickSelectAll}
        label='Flokkur'
        index={91}
      />
      {/* Tag dropdowns */}
      {Object.keys(dropdowns).map((category, idx) => (
        <Dropdown
          key={category}
          open={open}
          setOpen={setOpen}
          categories={dropdowns[category]}
          category={category}
          allSelected={allSelected[category]}
          onSelect={(tag: string) =>
            onClickCheckbox(category, tag, !dropdowns[category][tag])
          }
          label={getCategoryLabel(category)}
          index={90 - idx}
        />
      ))}
    </div>
  )
}

export default DropdownTree
